import React from 'react';
import { StyleSheet, View, } from 'react-native';
import { Path, Svg } from 'react-native-svg';
import { rem } from './values';
const BorderedSquircle = ({ size, color, style, svgStyle, borderStrokeProps, children, }) => {
    const svgProps = {
        style: svgStyle,
        width: rem(size),
        height: rem(size),
        fill: 'none',
    };
    switch (size) {
        case 40:
        case 44:
            return (<View style={[styles.container, style]}>
          <Svg {...svgProps} viewBox="0 0 41 41">
            <Path d="M20.5824 1.10815C27.2597 1.10815 32.0299 2.69239 35.139 5.80151C38.2482 8.91064 39.8324 13.6809 39.8324 20.3582C39.8324 27.0354 38.2482 31.8057 35.139 34.9148C32.0299 38.0239 27.2597 39.6082 20.5824 39.6082C13.9051 39.6082 9.13488 38.0239 6.02576 34.9148C2.91664 31.8057 1.3324 27.0354 1.3324 20.3582C1.3324 13.6809 2.91664 8.91064 6.02576 5.80151C9.13488 2.69239 13.9051 1.10815 20.5824 1.10815Z" strokeWidth={1.5} fill={color} {...borderStrokeProps}/>
          </Svg>
          <View style={styles.svg} pointerEvents="none">
            {children}
          </View>
        </View>);
        case 24:
            return (<View style={[styles.container, style]}>
          <Svg {...svgProps} viewBox="0 0 24 24">
            <Path d="M12 0C3.86053 0 0 3.86053 0 12C0 20.1395 3.86053 24 12 24C20.1395 24 24 20.1395 24 12C24 3.86053 20.1395 0 12 0Z" fill={color}/>
            <Path d="M12 0.75C15.9641 0.75 18.7351 1.6911 20.5225 3.47852C22.3096 5.26594 23.25 8.03625 23.25 12C23.25 15.9638 22.3096 18.7341 20.5225 20.5215C18.7351 22.3089 15.9641 23.25 12 23.25C8.03589 23.25 5.26495 22.3089 3.47754 20.5215C1.69044 18.7341 0.75 15.9638 0.75 12C0.75 8.03625 1.69044 5.26594 3.47754 3.47852C5.26495 1.6911 8.03589 0.75 12 0.75Z" strokeWidth={1.5} {...borderStrokeProps}/>
          </Svg>
          <View style={styles.svg} pointerEvents="none">
            {children}
          </View>
        </View>);
        default: {
            const _ = size;
            return null;
        }
    }
};
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    svg: {
        position: 'absolute',
    },
});
export default BorderedSquircle;
